
const getFirstNonMatchingItem = (defaultArray, objectsArray) => {
    const existingTypes = objectsArray.map(obj => obj.type);
    return defaultArray.find(item => !existingTypes.includes(item));
}

const allTypesExist = (defaultArray, objectsArray) => {
    const existingTypes = objectsArray.map(obj => obj.type);
    return defaultArray.every(item => existingTypes.includes(item));
}

exports.getFirstNonMatchingItem = getFirstNonMatchingItem
exports.allTypesExist = allTypesExist